<script setup lang="ts">
import { Button, Popover } from '@collector/shared-ui'
import { injectEventInfoConfig } from '@desktop/views/Relation/Sports/provide-inject'

import EventInfoPopoverContent from './EventInfoPopoverContent.vue'

// inject
const { isEventInfoPopoverOpen } = injectEventInfoConfig()!
</script>

<template>
  <Popover
    v-model="isEventInfoPopoverOpen"
    :trigger="{
      asChild: true,
    }"
    isContentHidden
  >
    <template #trigger>
      <!-- TODO: <Button :variant="light"> instead of :class -->
      <Button
        :class="{
          'bg-neutral-light-0 border-neutral-light-0': isEventInfoPopoverOpen,
          'border-neutral-light-7 bg-neutral-light-7 hover:bg-neutral-light-3 hover:border-neutral-light-3':
            !isEventInfoPopoverOpen,
        }"
        icon="info"
        size="sm"
        square
        data-testid="event-info-button"
      />
    </template>
    <template #content>
      <EventInfoPopoverContent />
    </template>
  </Popover>
</template>
